import { OrganizationProfile } from '@borg/types';

class OrganizationRepository extends Repository<OrganizationProfile> {
  get(id: number) {
    return this._get({
      url: () => `/organizations/${id}`,
      cache: 'always',
    });
  }
}

export const organizationRepository = new OrganizationRepository();
